import { createFileRoute } from "@tanstack/react-router";
import CignaMarketplaceInsurance, {
  config,
} from "@/pages/CignaMarketplaceInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/cigna-marketplace-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Cigna Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Cigna Marketplace insurance for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Cigna Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Cigna Marketplace insurance for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/cigna-marketplace-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/cigna-marketplace-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CignaMarketplaceInsurance />;
}
